import slick from "slick-carousel";
import axios from "axios";
import validate from 'jquery-validation';
import Popper from "popper.js";
import sliders from './sliders';
import buttons from './buttons';
import modals from './modals';
import forms from './forms';
import Scrollbar from 'smooth-scrollbar';

require("@fancyapps/fancybox");
window.jQuery = $;


axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

$(window).on('load', function () { // makes sure the whole site is loaded

    //Preloader

    setTimeout(() => {
        $('#status').fadeOut(); // will first fade out the loading animation
        $('#preloader').delay(800).fadeOut('slow'); // will fade out the white DIV that covers the website.
        $('body').delay(800).removeAttr("style");
        Scrollbar.initAll({alwaysShowTracks: true});
    }, 250);

});


$(document).ready(function () {


    // IMG to SVG
    if ($('.js-svg').length) {
        $('img.js-svg').each(function () {
            let $img = jQuery(this);
            const imgID = $img.attr('id');
            const imgClass = $img.attr('class');
            const imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                let $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                $svg = $svg.removeAttr('width');
                $svg = $svg.removeAttr('height');

                // Replace image with new SVG
                $img.replaceWith($svg);
            }, 'xml');
        });
    }

    // Smooth scroll

    $('.js-smooth-scroll').click(function (e) {
        e.preventDefault();

        let $currentModal = $($(this).parents(".js-modal"));

        if ($currentModal.length) {
            $currentModal.find('.js-modal-close-button').trigger('click');
        }

        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            || location.hostname == this.hostname) {
            const target = $(this).data('scroll-to');

            if (target === 'contacto') {
                window.journey && window.journey.addEvent('contact_click');
            }

            let $targetEl = $(`[data-scroll-id="${target}"]`)

            if ($(this.hash).length) {
                $targetEl = $(this.hash);
            }

            $targetEl = $targetEl.length ? $targetEl : $('[name=' + this.hash.slice(1) + ']');
            if ($targetEl.length) {
                $('html,body').animate({
                    scrollTop: $targetEl.offset().top - 125
                }, 1000);
                return false;
            }
        }
    });

    // Header

    const $header = $('.js-header');
    const clickDelay = 500;
    let clickDelayTimer = null;

    $header.find('.js-toggler').on('click', function () {
        // Toggle class
        $header.toggleClass('-open');

        // Block scroll
        if ($header.hasClass('-open')) {
            $('body').addClass('-header-open');
            $('html').css({ overflow: 'hidden' });
        } else {
            $('body').removeClass('-header-open');
            $('html').removeAttr("style");
        }


        // Icon
        if (clickDelayTimer === null) {

            let $burger = $(this);
            $burger.toggleClass('-active');

            if (!$burger.hasClass('-active')) {
                $burger.addClass('-closing');
            }

            clickDelayTimer = setTimeout(function () {
                $burger.removeClass('-closing');
                clearTimeout(clickDelayTimer);
                clickDelayTimer = null;
            }, clickDelay);
        }
    });

    $header.find('.js-backdrop').on('click', function () {
        $header.find('.js-toggler').trigger('click');
    });

    function numberWithDots(x) {
        let response;

        if (isNaN(x)) {
            response = NaN;
        } else {
            response = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            response = response.replace(/[.,]/g, function (x) {
                return x == ',' ? '.' : ',';
            });
        }

        return response;
    }

    function displayToday() {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;

        let yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }

        today = dd + '/' + mm + '/' + yyyy;

        return today;
    };

    // Form input validation

    let inputs = document.querySelectorAll('input, textarea, select');
    for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener('change', function (event) {
            event.target.classList.add('-interacted');
            $('.msg-success').remove();
        }, false);

        if (inputs[i].value && !inputs[i].classList.contains('-interacted')) {
            inputs[i].classList.add('-interacted');
        }
    }

    // My Toyota button
    $('.js-my-toyota').click(function (e) {
        if ($(e.target).is('.js-my-toyota-clear')) {
            $('.js-my-toyota').hide(400);
            axios.post('/api/clear_client_model').then(() => console.log('My Toyota cleared'));
        }
    });


    //Go back button
    $('#go-back').click(function (e) {
        e.preventDefault();
        window.history.back();
    })
});
